import { z } from 'zod';
import { TypeOfAPIError, TypeOfAPIResponse } from '@ninja/api-client';
import { APIFactoryOptions, factory } from '../../config/apiClientConfig';
import {
	requestSchema as createJourneyRequestSchema,
	responseSchema as createJourneyResponseSchema,
	dependentSchema,
	memberIdSchema,
	principalDetailsSchema,
} from './create-journey';

const requestSchema = createJourneyRequestSchema.merge(
	z.object({
		encryptedJourneyId: z.string(),
		principalDetails: principalDetailsSchema.merge(memberIdSchema),
		dependents: z.array(dependentSchema.merge(memberIdSchema)).optional(),
	})
);

const responseSchema = createJourneyResponseSchema;

const postUpdateJourney = (options: APIFactoryOptions) =>
	factory(options).createAPIDefinition({
		url: '/Member/updateJourney',
		method: 'POST',
		responseSchema: responseSchema,
		requestSchema: requestSchema,
		errorCodes: ['MaxNumberOfMembers'],
	});

export type UpdateJourneyRequest = z.infer<typeof requestSchema>;

export type UpdateJourneyResponse = TypeOfAPIResponse<ReturnType<typeof postUpdateJourney>>;

export type UpdateJourneyError = TypeOfAPIError<ReturnType<typeof postUpdateJourney>>;

export default postUpdateJourney;
